import styled from 'styled-components';
export const Fitinfoarea = styled.div `
    padding: calc(100vw*(79.5/375)) calc(100vw*(17/375)) calc(100vw*(50/375)) calc(100vw*(16/375));
`

export const Fitinfotit = styled.h1 `
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    padding-bottom : calc(100vw*(2/375));
`
export const Fitinfosubtit = styled.p `
    font-size: calc(100vw*(11/375));
    line-height: 1.55;
    color: #7f7f7f;
    padding-bottom : calc(100vw*(15/375));
`
export const Textarea = styled.textarea `
    width: 100%;
    height: calc(100vw*(153/375));
    border-radius: calc(100vw*(5/375));
    border: solid calc(100vw*(1/375)) #d5d5d5;
    background-color: #ffffff;
    font-size: calc(100vw*(14/375));
    line-height: 1.57;
    padding: calc(100vw*(10/375)) calc(100vw*(12/375));

    &::placeholder {
        color: #c6c6c6;
    }
    &:focus {
        border: solid calc(100vw*(1/375)) #ffcf19;
    }
`